<template>
    <div>
        <template v-if="CompanyPartialLeaves == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Company Partial Leaves</h1>
                <router-link v-if="CompanyPartialLeavesCrud" to="addCompanyPartialLeave" class="btn btn-primary float-right active">Add Partial Leaves</router-link>
            </div>
            <table id="leavesTable" class="table" style="width:100%">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Hours</th>
                        <th>Gender</th>
                        <th>Leave Types</th>
                        <th>Employment Types</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="CompanyPartialLeaves === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="CompanyPartialLeaves === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                CompanyPartialLeaves:null,
                CompanyPartialLeavesCrud:null,
            };
        },

        mounted() {
          var gThat = this;
            this.$Progress.start();
            this.can('company_partial_leaves|crud_company_partial_leaves').then(result => {
                this.CompanyPartialLeaves = result.company_partial_leaves;
                this.CompanyPartialLeavesCrud = result.crud_company_partial_leaves;
            }).then(result => {
                if(this.CompanyPartialLeaves == true){
                    this.getCompanyPartialLeavesData();
                }
            });
          window.softDelete = function(partialLeaveId){
            gThat.softDelete(partialLeaveId);
          }
        },

        methods: {
            getCompanyPartialLeavesData: function(){
                var that = this;
                $('#leavesTable').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "api/companyPartialLeaves",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'title'},
                        {data: 'hours', render: function(data,type,full){
                            return full.hours+' Hrs';
                        }},
                        {data: 'gender'},
                        {data: 'leave_types', render: function(data,type,full){
                            var arr = JSON.parse(full.leave_types);
                            var result = arr.map(function(val) {
                                return val.value;
                            }).join(',');
                            return result;
                        }},
                        {data: 'employment_types', render: function(data,type,full){
                            var arr = JSON.parse(full.employment_types);
                            var result = arr.map(function(val) {
                                return val;
                            }).join(', ');
                            return result;
                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editCompanyPartialLeave/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                        }, visible: that.CompanyPartialLeavesCrud},
                    ],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 4 ]
                    }],
                    "order": [[ 0, "desc" ]],
                });
            },
            softDelete(partialLeaveId) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/partialLeaveSoftDelete", {PartialLeaveId: partialLeaveId})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Partial Leave deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        }
        
    }
</script>
